export const MAX_ITEMS_PER_LIST = 13;
